<template>
  <div class="onboarding-wrapper">
    <div class="container">
      <div class="card">
        <h2>Onboarding</h2>
        <p>
          Vous pouvez relancer l’onboarding si vous souhaitez suivre une
          nouvelle visite guidée de la plateforme. C’est aussi un bon moyen de
          refaire le point sur les différentes fonctionnalités proposées par
          l’outil.
        </p>
        <Button
          class="primary icon icon-left onboarding-btn"
          label="Relancer l'onboarding"
          icon="bi-arrow-counterclockwise"
          @click="appStore.restartOnboarding()"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAppStore } from "@/stores/app.js";

const appStore = useAppStore();
</script>
